module.exports = __webpack_public_path__ + "media/images/home/book-00f0a0be878b9eaf9d9fff37c7822351.png";